/* eslint-disable react-hooks/exhaustive-deps */
import MsgToast from "./components/ingka/MsgToast";
import PublicRouter from "./router/PublicRouter";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useSessionStore } from "./store/sessionStore";

export default function App() {
  const [t, i18n] = useTranslation("global")
  const { language, toasts } = useSessionStore()

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])

  return (
    <>
      <div className="toastsContainer">
        {toasts?.map((toast, index) => (
          <MsgToast
            key={toast.title + index}
            id={index}
            body={toast.body}
            variant={toast.variant}
            title={toast.title} />
        ))}
      </div>
      <PublicRouter />
    </>
  );
}
